import { FormControl, Validators } from '@angular/forms';
import { passwordMatchValidator, passwordStrengthValidator } from './validators';

export const createPasswordControl = () => new FormControl('', [
    Validators.required,
    Validators.minLength(8),
    passwordStrengthValidator
]);
export const createConfirmPasswordControl = (passwordControlPath = 'password') => new FormControl('', [
    Validators.required,
    passwordMatchValidator(passwordControlPath)
]);